import { CTAButton } from "@/components/atoms/PromoBanners/RootBanner";
import { HeroSection } from "@/containers/HeroSection";
import { BREAKPOINTS } from "@/settings";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "usehooks-ts";

import { USP, USPType } from "./USP";

interface BaseLandingPageProps {
  heroTitle: string;
  pageTitle: string;
  navigateBack: string;
  ctaTitle: string;
  USPs: USPType[];
  onHandleCTA: () => void;
  children: React.ReactNode;
}

export const BaseLandingPage = ({
  heroTitle,
  pageTitle,
  navigateBack,
  ctaTitle,
  USPs,
  onHandleCTA,
  children,
}: BaseLandingPageProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const isTouchDevice = useMediaQuery(BREAKPOINTS.TOUCH_DEVICE.query);
  return (
    <div className="bg-panel-base min-h-screen">
      {!isTouchDevice && (
        <HeroSection
          title={heroTitle}
          titleBackgroundColor="bg-white/5"
          navigateBack={() => {
            const fromHome =
              (location.state as { from?: string } | null)?.from === "home";
            navigate(fromHome ? "/" : navigateBack);
          }}
        />
      )}
      <main className="flex flex-col justify-center touch-device:items-start mx-auto touch-device:max-w-content mobile:px-12 text-sm mobile:text-base relative">
        <section className="px-4 z-1">
          <h2 className="mt-4 mobile:mt-10 text-left bg-gradient-to-r from-primary-washed-blue via-primary-blue to-primary-washed-blue  bg-clip-text text-transparent mobile:w-150 text-3xl mobile:text-5xl font-bold">
            {pageTitle}
          </h2>
          <section className="flex flex-col py-6 mobile:py-8 gap-y-4 mobile:gap-y-6 mt-6 touch-device:mt-12">
            {USPs.map((usp) => {
              return <USP {...usp} />;
            })}
          </section>
        </section>
        <section className="flex flex-col justify-center">
          <div className="mx-auto touch-device:ml-10 my-4 mt-6 touch-device:mt-12">
            <CTAButton label={ctaTitle} onClick={onHandleCTA} />
          </div>
        </section>
        {children}
      </main>
    </div>
  );
};
